import React from "react";
import styled from "styled-components";
import {
  ContainerInsetCardClassName,
  LinkType,
  PageSectionClassName,
  SectionSlideshow,
  SectionSlideshowClassName,
  SectionSlideshowProps,
  Theme,
} from "@literati/public-ui-shared-react";

/** This is the className that will be pre-pended to all of TeacherPartnerSectionTestimonials's inner component classNames */
export const TEACHER_PARTNER_SECTION_TESTIMONIALS_CLASS_BASE =
  "teacher-partner-section-testimonials";

/** These are all of the internal classNames that are used within the TeacherPartnerSectionTestimonials component */
export const TeacherPartnerSectionTestimonialsClassName = {
  BASE: TEACHER_PARTNER_SECTION_TESTIMONIALS_CLASS_BASE,
} as const;

const StyledSectionSlideshow = styled(SectionSlideshow)`
  .${PageSectionClassName.CONTENT_SPACING_CHILDREN} {
    padding: 2rem 0 0;
  }

  .${ContainerInsetCardClassName.INSET_BORDER} {
    border: none;
  }

  .${SectionSlideshowClassName.DESKTOP_ITEM_CONTAINER} {
    padding: 3rem 1rem 0;
  }

  ${({ theme }) => theme.media.md} {
    .${PageSectionClassName.CONTENT_SPACING_CHILDREN} {
      padding: 0;
    }
  }
`;

export const sectionSlideshowDefaultProps: TeacherPartnerSectionTestimonialsProps =
  {
    imageCopyItems: [
      {
        key: `testimonial-slide-0`,
        subtext:
          "“I’m a reading specialist, and all the books were new to me and wonderful. I would recommend Literati to all friends and students.”",
        attribution: "— Julia M., Teacher",
        imageProps: {
          alt: "Woman leaning on Literati Box.",
          height: 120,
          src: "https://images.ctfassets.net/vqtz4cq2w5ts/2DXG4aQPOZ05t1Umilt1BH/eae7e7547cd029eb908ba7afaca2237d/Testimonial_Woman_2x.png",
          width: 120,
        },
      },
      {
        key: `testimonial-slide-1`,
        subtext:
          "“My daughter has had her passion for reading rekindled because of the consistent new book rotation coming into the house.”",
        attribution: "— Jason W., Literati Parent",
        imageProps: {
          alt: "Girl smiling and holding book up to camera.",
          height: 120,
          src: "https://images.ctfassets.net/vqtz4cq2w5ts/lU8IqEcmWgVD06h2WcYNE/d666e912c679a428c5af8f816b501859/Testimonial_Female_Child_Holding_Book_2x.png",
          width: 120,
        },
      },
      {
        key: `testimonial-slide-2`,
        subtext:
          "“I love that Literati sends some books for pleasure and books that are challenging but age-appropriate as well!”",
        attribution: "— Laura M., Parent",
        imageProps: {
          alt: "Boy smiling holding open book.",
          height: 120,
          src: "https://images.ctfassets.net/vqtz4cq2w5ts/7EBNliwo9J3B7QQUgoYXMA/0a577c85f42503812aee38dfb05cd347/Testimonial_Male_Child_Holding_Book_2x.png",
          width: 120,
        },
      },
    ],
    linkType: LinkType.LINK_NEXT,
    pageSectionProps: {
      bgColor: "periwinkleTint5",
      primaryHeading: "Real Readers. Real Progress.",
    },
    variant: "imageCopyItem",
  };

export type TeacherPartnerSectionTestimonialsProps = SectionSlideshowProps;

export const TeacherPartnerSectionTestimonials = ({
  className = "",
  imageCopyItems = sectionSlideshowDefaultProps.imageCopyItems,
  linkType = sectionSlideshowDefaultProps.linkType,
  pageSectionProps = sectionSlideshowDefaultProps.pageSectionProps,
}: TeacherPartnerSectionTestimonialsProps) => {
  return (
    <Theme>
      <StyledSectionSlideshow
        variant="imageCopyItem"
        className={`${TeacherPartnerSectionTestimonialsClassName.BASE} ${className}`}
        imageCopyItems={imageCopyItems}
        linkType={linkType}
        pageSectionProps={pageSectionProps}
      />
    </Theme>
  );
};

export default TeacherPartnerSectionTestimonials;
